import { message, Popconfirm, Tooltip } from 'antd'

// assets
import AddCandidatesDropdown from '../../modules/jobApplications/components/AddCandidateDropdown'

import { IoIosLink } from 'react-icons/io'
import { AiFillEdit } from 'react-icons/ai'
import { IoArchive } from 'react-icons/io5'
import { IoEyeSharp } from 'react-icons/io5'
import { RiArrowGoBackLine } from 'react-icons/ri'

// routes
import { PUBLIC_ROUTES } from '../../routes'

const BackAndEdit = ({
    isBack = true,
    onBack = null,
    isEdit = true,
    onEdit = null,
    onArchive = null,
    state,
    params,
}) => {
    return (
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <Tooltip title="Copy Job Link">
                <IoIosLink
                    size={26}
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const relativeUrl = PUBLIC_ROUTES.jobCandidateDetail(
                            params.id
                        )
                        const url = `${window.location.origin}${relativeUrl}`

                        navigator.clipboard
                            .writeText(url)
                            .then(() => {
                                message.success('Job link copied to clipboard!')
                            })
                            .catch(() => {
                                message.error('Failed to copy link')
                            })
                    }}
                    color="#4F46E5"
                />
            </Tooltip>
            <Tooltip title="View Job">
                <IoEyeSharp
                    size={26}
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = PUBLIC_ROUTES.jobCandidateDetail(params.id)
                        window.open(url, '_blank')
                    }}
                    color="#4F46E5"
                />
            </Tooltip>
            {isEdit && (
                <Tooltip title="Edit Job">
                    <AiFillEdit
                        onClick={onEdit}
                        size={26}
                        style={{ cursor: 'pointer' }}
                        color="#4F46E5"
                    />
                </Tooltip>
            )}

            <Popconfirm
                title="Archive Job"
                description="Are you sure to archive this Job?"
                onConfirm={onArchive}
                icon={null}
                // onCancel={cancel}
                okText="Yes"
                cancelText="Cancel"
                okButtonProps={{
                    style: {
                        padding: '0px 10px',
                        backgroundColor: '#4F46E5',
                    },
                }}
                cancelButtonProps={{
                    style: {
                        backgroundColor: 'transparent',
                        border: 'none',
                        padding: '0px 10px',
                        color: 'black',
                        boxShadow: 'none',
                    },
                }}
            >
                <Tooltip title="Archive Job">
                    <IoArchive
                        size={22}
                        style={{ cursor: 'pointer' }}
                        color="#f74a4aff"
                    />
                </Tooltip>
            </Popconfirm>
            {isBack && (
                <Tooltip title="Back">
                    <RiArrowGoBackLine
                        onClick={onBack}
                        size={22}
                        style={{
                            cursor: 'pointer',
                        }}
                    />
                </Tooltip>
            )}
            <AddCandidatesDropdown state={state} />
        </div>
    )
}

export default BackAndEdit
